module.exports = __webpack_public_path__ + "img/Yousef_Khaled.0f17db19.png";